export enum ShipmentType {
  BOI = 'BOI',
  NON_BOI = 'NON_BOI',
}
